import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const hasProcessed = useRef(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = new URLSearchParams(window.location.hash.slice(1)).get("session_id");
    window.history.replaceState(null, "", window.location.pathname);
    if (!sessionId) {
      window.location.href = "/login";
      return;
    }
    api
      .post("/api/auth/google/session", { session_id: sessionId, ref: localStorage.getItem("fp_ref") || "" })
      .then(({ data }) => {
        login(data);
        navigate(data.is_new ? "/app/welcome" : "/app", { replace: true });
      })
      .catch(() => {
        window.location.href = "/login";
      });
  }, [login, navigate]);

  return (
    <div data-testid="auth-callback-loading" className="min-h-screen bg-[#0B0E14] flex items-center justify-center font-mono text-sm text-[#5A6272]">
      Signing you in…
    </div>
  );
}
